import { getBalanceTypes } from './get-balance-types';
export const getPrimaryBalanceType = () => {
    return getBalanceTypes().find(balanceType => balanceType.isPrimary);
};
